import axios from "axios";
import { setSubscriptionStatus } from "../store/userSlice";
import { toast } from "react-toastify";
import { store } from "../store/store";
const apiClient = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const errorCode = error.response?.data?.code;

    if (status === 403 && errorCode === "SUBSCRIPTION_ERROR") {
      store.dispatch(setSubscriptionStatus(true));
      toast.error(
        "Your subscription has expired. Please renew to continue accessing the service.",
      );
    }

    if (status === 401) {
      localStorage.removeItem("token");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/portal/login";
      }
    }

    return Promise.reject(error.response?.data || error.message);
  },
);

const axiosAPI = async (method, path, data = null) => {
  try {
    const response = await apiClient({
      method: method.toUpperCase(),
      url: `/${path}`,
      data: method.toUpperCase() === "GET" ? undefined : (data ?? undefined),
    });

    return response.data;
  } catch (error) {
    console.error("Axios API Error:", error);
    throw error;
  }
};

export default axiosAPI;
